import React from 'react';
import { Select } from '@applyboard/crystal-ui';
import { queryParameterContext } from '../../context';
import { SortAscendingOutlineIcon, SortDescendingOutlineIcon } from '@applyboard/ui-icons';

const sortFields = [
  { label: 'Country (A-Z)', value: 'countryCode', icon: SortAscendingOutlineIcon },
  { label: 'Country (Z-A)', value: '-countryCode', icon: SortDescendingOutlineIcon },
  { label: 'Source Course (A-Z)', value: 'sourceCourseName', icon: SortAscendingOutlineIcon },
  { label: 'Source Course (Z-A)', value: '-sourceCourseName', icon: SortDescendingOutlineIcon },
  { label: 'Equivalent Course (A-Z)', value: 'equivalentCourseName', icon: SortAscendingOutlineIcon },
  { label: 'Equivalent Course (Z-A)', value: '-equivalentCourseName', icon: SortDescendingOutlineIcon },
  { label: 'Education Level (A-Z)', value: 'sourceEducationLevelName', icon: SortAscendingOutlineIcon },
  { label: 'Education Level (Z-A)', value: '-sourceEducationLevelName', icon: SortDescendingOutlineIcon },
];

export function Sort() {
  const { value, setValue } = queryParameterContext.useFilterField('sort', 'PrimaryFilter');
  const selectedValue = value || 'countryCode';
  const currentField = sortFields.find((field) => field.value === selectedValue);
  const placeholderLabel = currentField ? `Sort: ${currentField.label}` : 'Sort';

  return (
    <Select
      value={selectedValue}
      aria-label="Sort"
      placeholder={placeholderLabel}
      onChange={(value) => setValue(value)}
      emphasis="highlighted"
      intent="primary"
      placeholderVariant="indicator"
      appearance="styled"
    >
      {sortFields.map((field) => (
        <Select.Option key={field.value} label={field.label} value={field.value} icon={field.icon} />
      ))}
    </Select>
  );
}
